import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { Select } from '@ipc/ipc-components';
import BalanceOnHandReportSelectionCriteriaContainer from './BalanceOnHandReportSelectionCriteriaContainer';
import { getLeftCheckedMailProcessingCenters } from '../../../../common/user/redux/selectors/UserDataSelectors';
import { getAssetType } from '../../../../common/asset-types/redux/selectors/AssetTypesSelectors';
import { tableLoadData } from '../../../../common/tables/actions/ListTableActions';
import TableDefinitions from '../../../../common/TableDefinitions';
import ListTable from '../../../../common/tables/ListTable';
import { getColumns, getData, getIsLoading } from '../redux/selectors/BalanceOnHandReportSelector';
import downloadTypes from '../../../../common/tables/excel/DownloadTypes';
import { BalanceOnHandReportContainerStyle } from './BalanceOnHandReportContainer.styles';
import { getGlobalStartDate } from '../../../../common/selection-criteria/period/redux/selectors/GlobalPeriodSelectionSelectors';
import { setGlobalStartDateSelectionActionCreator } from '../../../../common/selection-criteria/period/redux/actions/GlobalPeriodSelectionActions';

const searchOptions = [
  { label: 'All', value: 'all' },
  { label: 'On Hand > BOH Max Threshold', value: 'boh-higher-than-max-threshold' },
  { label: 'On Hand < BOH Min Threshold', value: 'boh-lower-than-min-threshold' },
];

class BalanceOnHandReportContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showResult: false,
      selectedDate: this.props.globalStartDate,
      resultFilter: 'all',
    };
  }

  onDateChange = (newDate) => {
    this.setState({
      selectedDate: newDate,
    });
    this.props.setGlobalStartDateSelectionActionCreator(newDate);
  }

  onFilterChange = (selectedOption) => {
    this.setState({
      resultFilter: selectedOption.value,
    });
    this.props.tableLoadData(
      { tableId: 'REPORTING_BALANCE_ON_HAND_PAGE' },
      this.props.appContext.appContext,
      {
        impcCodes: this.props.checkedMailProcessingCenters,
        inputDate: this.state.selectedDate,
        resultFilter: selectedOption.value,
      },
    );
  }

  onCriteriaApply = () => {
    this.setState({
      showResult: true,
    });

    this.props.tableLoadData(
      { tableId: 'REPORTING_BALANCE_ON_HAND_PAGE' },
      this.props.appContext.appContext,
      {
        impcCodes: this.props.checkedMailProcessingCenters,
        inputDate: this.state.selectedDate,
        resultFilter: this.state.resultFilter,
      },
    );
  };

  render() {
    const { isLoading, data, columns } = this.props;
    const { showResult, selectedDate } = this.state;

    return (
      <div>
        <BalanceOnHandReportSelectionCriteriaContainer
          open={data.length === 0}
          title="BALANCE ON HAND REPORT"
          onApply={this.onCriteriaApply}
          selectedDate={selectedDate}
          onDateChange={this.onDateChange}
        />
        <BalanceOnHandReportContainerStyle>
          <div className="general-content-container">
            {(showResult || data.length > 0) && (
              <div className="full-width">
                <Select
                  placeholder="All"
                  className="select-box"
                  options={searchOptions}
                  onChange={this.onFilterChange}
                />
                <div className="list-table-container" style={{ paddingBottom: '20px' }}>
                  <ListTable
                    listId={TableDefinitions.REPORTING_BALANCE_ON_HAND_PAGE.id}
                    loading={isLoading}
                    columns={columns}
                    data={data}
                    keyField="id"
                    selectCheckbox
                    downloadType={downloadTypes.EXCEL}
                    downloadFileAs="BoH_Report"
                    pagination
                  />
                </div>
              </div>
            )}
          </div>
        </BalanceOnHandReportContainerStyle>
      </div>
    );
  }
}

BalanceOnHandReportContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  appContext: PropTypes.objectOf(PropTypes.string),
  checkedMailProcessingCenters: PropTypes.arrayOf(PropTypes.string),
  tableLoadData: PropTypes.func,
  isLoading: PropTypes.bool,
  globalStartDate: PropTypes.instanceOf(Date),
  setGlobalStartDateSelectionActionCreator: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    data: getData(state),
    columns: getColumns(state),
    checkedMailProcessingCenters: getLeftCheckedMailProcessingCenters(state),
    appContext: getAssetType(state),
    isLoading: getIsLoading(state),
    globalStartDate: getGlobalStartDate(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  tableLoadData,
  setGlobalStartDateSelectionActionCreator,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(BalanceOnHandReportContainer);
